import type { ReactNode } from 'react';

export const symbol_fitness_tracker: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M384-80q-10 0-18-5.5T355-101l-36-118q-18-12-28.5-31.5T280-293v-374q0-23 11-43t29-32l36-117q3-10 10.5-15.5T384-880h192q10 0 17.5 5.5T604-859l36 117q18 12 29 32t11 43v374q0 23-10.5 42.5T641-219l-36 118q-3 10-11 15.5T576-80H384Zm22-60h147l20-63H386l20 63Zm-36-123h220q13 0 21.5-8.5T620-293v-374q0-13-8.5-21.5T590-697H370q-13 0-21.5 8.5T340-667v374q0 13 8.5 21.5T370-263Zm17-494h185l-19-63H406l-19 63Zm92 554Zm0-554Z"
		/>
	</svg>
);
